// extracted by mini-css-extract-plugin
export var banner = "_13-0";
export var icon = "_13-1";
export var message = "_13-2";